module.exports = __webpack_public_path__ + "static/img/baochi@2x.3fde4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/baochi@2x.png
// module id = wAOd
// module chunks = 1